import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ServiceGuard } from '../_guards/service.guard';
import { EnvSpecific } from '../environs/models/env-specific';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class GiftCardErrorService {

  constructor(private _http: Http, private _serviceGuard: ServiceGuard) { }

  getToken(envSpecific: EnvSpecific) {
    const grant_type = envSpecific.grantType;
    const client_id = envSpecific.apiName;
    const client_secret = envSpecific.apiSecret;
    const scope = envSpecific.scope;

    const body = new HttpParams().set('client_id', client_id)
    .set('grant_type', grant_type)
    .set('client_secret', client_secret)
    .set('scope', scope);

    return this._http
      .post(envSpecific.authority + '/oauth2/token', body.toString(), {
        headers: this._serviceGuard.authTokenHeaders()
      })
      .map((response: Response) => response.json());
  }
  getContactId(envSpecific: EnvSpecific, hashCode: string) {
    return this._http
      .get(envSpecific.orionServiceUrl + '/contacts/v2/gdpr/contactHash?hashCode=' + hashCode, {
        headers: this._serviceGuard.authJsonHeaders()
      })
      .map((response: Response) => response.json())
      .do(d => console.log('All: ' + JSON.stringify(d)));
  }
}
